import request from '@/utils/request'

//const serverURL = "https://vab-unicloud-3a9da9.service.tcloudbase.com";
//const apiURL = "/notice/getList";

export function getStaffs(params) {
  return request({
    url: '/staff/findList',
    method: 'get',
    params,
  })
}

export function getAllStaffs(params) {
  return request({
    url: '/staff/findAll',
    method: 'get',
    params,
  })
}

export function getStaffShareCode(params) {
  return request({
    url: '/staff/findShareCode',
    method: 'get',
    params,
  })
}

export function addStaff(data) {
  return request({
    url: '/staff/create',
    method: 'post',
    data,
  })
}

export function editStaff(data) {
  return request({
    url: '/staff/update',
    method: 'post',
    data,
  })
}

export function editUser(data) {
  return request({
    url: '/staff/updateMe',
    method: 'post',
    data,
  })
}

export function delStaff(data) {
  return request({
    url: '/staff/remove',
    method: 'post',
    data,
  })
}

export function getIndustrys(params) {
  return request({
    url: '/branch/findIndustryList',
    method: 'get',
    params,
  })
}

export function getAllIndustrys(params) {
  return request({
    url: '/branch/findIndustryAll',
    method: 'get',
    params,
  })
}

export function addIndustry(data) {
  return request({
    url: '/branch/createIndustry',
    method: 'post',
    data,
  })
}

export function editIndustry(data) {
  return request({
    url: '/branch/updateIndustry',
    method: 'post',
    data,
  })
}

export function delIndustry(data) {
  return request({
    url: '/branch/removeIndustry',
    method: 'post',
    data,
  })
}

export function getBranchs(params) {
  return request({
    url: '/branch/findList',
    method: 'get',
    params,
  })
}

export function getAllBranchs(params) {
  return request({
    url: '/branch/findAll',
    method: 'get',
    params,
  })
}

export function addBranch(data) {
  return request({
    url: '/branch/create',
    method: 'post',
    data,
  })
}

export function editBranch(data) {
  return request({
    url: '/branch/update',
    method: 'post',
    data,
  })
}

export function delBranch(data) {
  return request({
    url: '/branch/remove',
    method: 'post',
    data,
  })
}

export function getDepartments(params) {
  return request({
    url: '/branch/findDepartmentList',
    method: 'get',
    params,
  })
}

export function addDepartment(data) {
  return request({
    url: '/branch/createDepartment',
    method: 'post',
    data,
  })
}

export function editDepartment(data) {
  return request({
    url: '/branch/updateDepartment',
    method: 'post',
    data,
  })
}

export function delDepartment(data) {
  return request({
    url: '/branch/removeDepartment',
    method: 'post',
    data,
  })
}

export function getLogs(params) {
  return request({
    url: '/app/findLogList',
    method: 'get',
    params,
  })
}

export function getAllAuthorities(params) {
  return request({
    url: '/staff/findAuthorityAll',
    method: 'get',
    params,
  })
}

export function getPeopleAllPermissions(params) {
  return request({
    url: '/staff/findPeoplePermissionAll',
    method: 'get',
    params,
  })
}

export function setupPeoplePermission(data) {
  return request({
    url: '/staff/setupPeoplePermission',
    method: 'post',
    data,
  })
}

// 批量新增员工：
// post staff/createBatch 参数：file //excel表url
// excel表格式：
// --------------------
// 工号 | 密码 | 姓名 | 手机号 | 职务| 权限
// -----------------------
// C001 | 123456 | 张三 | 182... | 老师 | READ_MATCH_ANSWER
export function createBatch(data) {
  return request({
    url: '/staff/createBatch',
    method: 'post',
    data,
  })
}
